import React, {Suspense} from 'react'
import useLogRocket from '@helpers/logrocket/useLogRocket'
import usePosthog from '@helpers/posthog/usePosthog'
import useActiveSessionNotifier from '@hooks/useActiveSessionNotifier'
import Sentry from '@providers/Sentry'
import url from '@providers/url'

export default function NonSsrRoot({pageProps}) {
  useActiveSessionNotifier({pageProps})
  useLogRocket()
  usePosthog({pageProps})

  return (
    <div>
      <link rel="preconnect" href={url} />
      <Suspense fallback={null}>
        <Sentry />
      </Suspense>
    </div>
  )
}
